export const AUTH_OAUTHPREMIUMFLOW_ENABLED_PARTNERIDS =
  'web.auth.oauthPremiumFlow.enabled.partnerIds';
export const AUTH_OAUTHPREMIUMFLOW_ENABLED_PARTNERIDSKUS =
  'web.auth.oauthPremiumFlow.enabled.partnerIdSkus';
export const AUTH_OAUTHPREMIUMFLOW_ENABLED_PARTNERIDUPSELLDEFAULTS =
  'web.auth.oauthPremiumFlow.enabled.partnerIdUpsellDefaults';
export const AUTH_PAYMENT_FORM_PREVIEW_ENABLED =
  'web.auth.paymentForm.preview.enabled';
